const semver = require('semver')
const dateValidator = require('is-my-date-valid')
const jsonValidator = require('is-my-json-valid')
const uuidValidator = require('is-my-uuid-valid')
const testConditions = require('@dooer/test-conditions')
const dotProp = require('dot-prop')

const intervalValidator = require('./lib/is-my-interval-valid')
const languageTagValidator = require('./lib/is-my-language-tag-valid')
const passwordValidator = require('./lib/is-my-password-valid')
const phoneNumberValidator = require('./lib/is-my-phone-number-valid')
const svensktBankClearingnummerValidator = require('./lib/is-my-svenskt-bank-clearingnummer-valid')
const svensktBankKontonummerValidator = require('./lib/is-my-svenskt-bank-kontonummer-valid')
const svensktBankgironummerValidator = require('./lib/is-my-svenskt-bankgironummer-valid')
const svensktPlusgironummerValidator = require('./lib/is-my-svenskt-plusgironummer-valid')
const svensktOrgainsationsnummerValidator = require('./lib/is-my-svenskt-orginsationsnummer-valid')
const svensktPersonnummerValidator = require('./lib/is-my-svenskt-personnummer-valid')
const svensktPostnummerValidator = require('./lib/is-my-svenskt-postnummer-valid')
const svensktBgOcrnummerValidator = require('./lib/is-my-svenskt-bg-ocrnummer-valid')
const svenskCompanyCarModellkodValidator = require('./lib/is-my-svensk-company-car-modellkod-valid')
const vatNumberValidator = require('./lib/is-my-vat-number-valid')
const swedishTaxTableNumberValidator = require('./lib/is-my-swedish-tax-table-number-valid')
const svensktSamordningsnummerValidator = require('./lib/is-my-svenskt-samordningsnummer-valid')
const svensktIdNummerValidator = require('./lib/is-my-svenskt-id-nummer-valid')
const httpUriValidator = require('./lib/is-my-http-uri-valid')
const base61UuidValidator = require('./lib/is-my-base61-uuid-valid')
const currencyValidator = require('./lib/is-my-currency-valid')
const countryCodeValidator = require('./lib/is-my-country-code-valid')
const looseSchema = require('./lib/loose-schema')
const timeValidator = require('./lib/is-my-time-valid')

const createError = require('./errors')

const dateIsValid = dateValidator({ format: 'YYYY-MM-DD' })
const ibantools = require('ibantools')
const intervalIsValid = intervalValidator()
const languageTagIsValid = languageTagValidator()
const passwordIsValid = passwordValidator()
const phoneNumberIsValid = phoneNumberValidator()
const svensktBankClearingnummerIsValid = svensktBankClearingnummerValidator()
const svensktBankKontonummerIsValid = svensktBankKontonummerValidator()
const svensktBankgironummerIsValid = svensktBankgironummerValidator()
const svensktPlusgironummerIsValid = svensktPlusgironummerValidator()
const svensktOrgainsationsnummerIsValid = svensktOrgainsationsnummerValidator()
const svensktPersonnummerIsValid = svensktPersonnummerValidator()
const svensktPostnummerIsValid = svensktPostnummerValidator()
const uuidIsValid = uuidValidator({ letterCase: 'lower' })
const uuidIsValidRelaxed = uuidValidator()
const svensktBgOcrnummerIsValid = svensktBgOcrnummerValidator()
const svenskCompanyCarModellkodIsValid = svenskCompanyCarModellkodValidator()
const vatNumberIsValid = vatNumberValidator()
const swedishTaxTableNumberIsValid = swedishTaxTableNumberValidator()
const svensktSamordningsnummerValid = svensktSamordningsnummerValidator()
const svensktIdNummerIsValid = svensktIdNummerValidator()
const httpUriIsValid = httpUriValidator()
const base61UuidValid = base61UuidValidator()
const currencyValid = currencyValidator()
const countryCodeValid = countryCodeValidator()
const timeValid = timeValidator()

const defaultValidatorOpts = {
  greedy: true,
  verbose: true,
  formats: {
    bic: input => (typeof input === 'string' ? ibantools.isValidBIC(input) : true),
    date: input => (typeof input === 'string' ? dateIsValid(input) : true),
    iban: input => (typeof input === 'string' ? ibantools.isValidIBAN(ibantools.electronicFormatIBAN(input)) : true),
    interval: input => (typeof input === 'string' ? intervalIsValid(input) : true),
    'language-tag': input => (typeof input === 'string' ? languageTagIsValid(input) : true),
    password: input => (typeof input === 'string' ? passwordIsValid(input) : true),
    'phone-number': input => (typeof input === 'string' ? phoneNumberIsValid(input) : true),
    semver: input => (typeof input === 'string' ? Boolean(semver.valid(input)) : true),
    'svenskt-bank-clearingnummer': input =>
      typeof input === 'string' ? svensktBankClearingnummerIsValid(input) : true,
    'svenskt-bank-kontonummer': input => (typeof input === 'string' ? svensktBankKontonummerIsValid(input) : true),
    'svenskt-bankgironummer': input => (typeof input === 'string' ? svensktBankgironummerIsValid(input) : true),
    'svenskt-plusgironummer': input => (typeof input === 'string' ? svensktPlusgironummerIsValid(input) : true),
    'svenskt-organisationsnummer': input =>
      typeof input === 'string' ? svensktOrgainsationsnummerIsValid(input) : true,
    'svenskt-personnummer': input => (typeof input === 'string' ? svensktPersonnummerIsValid(input) : true),
    'svenskt-postnummer': input => (typeof input === 'string' ? svensktPostnummerIsValid(input) : true),
    uuid: input => (typeof input === 'string' ? uuidIsValid(input) : true),
    'uuid-relaxed': input => (typeof input === 'string' ? uuidIsValidRelaxed(input) : true),
    'svenskt-bg-ocrnummer': input => (typeof input === 'string' ? svensktBgOcrnummerIsValid(input) : true),
    'svensk-company-car-modellkod': input =>
      typeof input === 'string' ? svenskCompanyCarModellkodIsValid(input) : true,
    'vat-number': input => (typeof input === 'string' ? vatNumberIsValid(input) : true),
    'svenskt-skattetabellnummer': input => (typeof input === 'string' ? swedishTaxTableNumberIsValid(input) : true),
    'svenskt-samordningsnummer': input => (typeof input === 'string' ? svensktSamordningsnummerValid(input) : true),
    'svenskt-id-nummer': input => (typeof input === 'string' ? svensktIdNummerIsValid(input) : true),
    'http-uri': input => (typeof input === 'string' ? httpUriIsValid(input) : true),
    'base61-uuid': input => (typeof input === 'string' ? base61UuidValid(input) : true),
    currency: input => (typeof input === 'string' ? currencyValid(input) : true),
    'country-code': input => (typeof input === 'string' ? countryCodeValid(input) : true),
    time: input => (typeof input === 'string' ? timeValid(input) : true),
  },
}

function shouldDisplay({ schema, formData, pathName }) {
  const displayConditions = dotProp.get(schema, 'ui.displayConditions')
  if (!displayConditions) return true

  return testConditions(displayConditions, formData, { relativeTo: pathName })
}

function stripErrorPath(pathName) {
  return pathName
    .replace(/^data\./, '')
    .replace('data["', '')
    .replace('["', '.')
    .replace('"]', '')
}

/**
 * @returns {string}
 */
function formatValidationErrors(errors) {
  return (errors || []).map(x => `${x.field} ${x.message}`).join(', ')
}

function requireValid(validator, data, schema) {
  if (isValid(validator, data, schema)) return

  throw createError('failed-validation', {
    message: formatValidationErrors(validator.errors),
    validationErrors: validator.errors,
  })
}
function isValid(validator, data, schema) {
  validator(data)

  if (!validator.errors) return true
  const filteredErrors = validator.errors.filter(error => {
    if (error.message !== 'is required') return true
    const key = stripErrorPath(error.field)
    const res = shouldDisplay({
      formData: data,
      schema: dotProp.get(schema, 'properties.' + key.replace('.', '.properties.')),
      pathName: key,
    })
    return res
  }, {})

  validator.errors = filteredErrors

  return filteredErrors.length === 0
}
/**
 * @param {object} schema JSON Schema definition
 */
function createValidator(schema, createValidatorOpts = _ => _) {
  if (schema.$schema) throw new TypeError("Don't specify a $schema, this module only uses draft-04")

  const validator = jsonValidator(schema, createValidatorOpts(defaultValidatorOpts))

  return {
    get errors() {
      return validator.errors
    },

    get errorMessage() {
      return formatValidationErrors(validator.errors)
    },

    /**
     * @param {any} data Data to validate
     */
    isValid(data) {
      return isValid(validator, data, schema)
    },

    /**
     * @throws Will throw a `failed-validation` error on invalid data
     * @param {any} data Data to validate
     */
    requireValid(data) {
      requireValid(validator, data, schema)
    },
  }
}

module.exports = createValidator
module.exports.looseSchema = looseSchema
